import { TabEightContainer } from './tab-eight-container';
import { TabFiveContainer } from './tab-five-container';
import { TabFourContainer } from './tab-four-container';
import { TabNineContainer } from './tab-nine-container';
import { TabOneContainer } from './tab-one-container';
import { TabSevenContainer } from './tab-seven-container';
import { TabSixContainer } from './tab-six-container';
import { TabThreeContainer } from './tab-three-container';
import { TabTwoContainer } from './tab-two-container';

export {
  TabOneContainer,
  TabTwoContainer,
  TabThreeContainer,
  TabFourContainer,
  TabFiveContainer,
  TabSixContainer,
  TabSevenContainer,
  TabEightContainer,
  TabNineContainer,
};
